/**
 * DOM
 */
jQuery(document).ready(function ($) {

    function initSliders() {

        // Évite la double initialisation
        if ($('.bx-wrapper').length > 0) return;

        // ── slider principal ──────────────────────────────────────
        $('.slider').each(function () {
            var ul    = $(this);
            var count = ul.children().length;
            if (count > 1) {
                ul.bxSlider({
                    nextText:  '<i class="fa-light fa-arrow-right-to-line"></i>',
                    prevText:  '<i class="fa-light fa-arrow-left-to-line"></i>',
                    pager:     false,
                    auto:      true,
                    pause:     4000,
                    autoHover: true
                });
            }
        });

        // ── slider logos ──────────────────────────────────────────
        $('.sliderLogo').each(function () {
            var w         = $(window).width();
            var r_largeur = w < 550 ? 1 : w < 750 ? 3 : 5;
            var ul        = $(this);
            var count     = ul.children().length;
            if (count > 1) {
                ul.bxSlider({
                    controls:   false,
                    pager:      false,
                    auto:       true,
                    pause:      4000,
                    autoHover:  false,
                    minSlides:  r_largeur,
                    maxSlides:  r_largeur,
                    moveSlides: 1,
                    speed:      1500,
                    slideWidth: 3000,
                });
            }
        });

        // ── citations ─────────────────────────────────────────────
        $('.carouselCitations').each(function () {
            var ul    = $(this);
            var count = ul.children().length;
            if (count > 1) {
                ul.bxSlider({
                    mode:       'horizontal',
                    startSlide: 0,
                    speed:      1000,
                    controls:   false,
                    pager:      true,
                    auto:       true,
                    pause:      5000,
                });
            }
        });

        // ── étapes ────────────────────────────────────────────────
        $('.slider_etapes').each(function () {
            var ul    = $(this);
            var count = ul.children().length;
            if (count > 1) {
                ul.bxSlider({
                    mode:         'horizontal',
                    startSlide:   0,
                    speed:        1000,
                    controls:     false,
                    infiniteLoop: false,
                    pager:        true,
                    auto:         false,
                    pause:        5000,
                });
            }
        });

        // ── carousel HDP ──────────────────────────────────────────
        $('.carouselHDP').each(function () {
            var ul    = $(this);
            var count = ul.children().length;
            if (count > 1) {
                ul.bxSlider({
                    mode:         'fade',
                    speed:        1500,
                    controls:     false,
                    pager:        false,
                    auto:         true,
                    pause:        4000,
                    autoHover:    false,
                    infiniteLoop: true,
                });
            }
        });

        // ── carousel paraphotos ───────────────────────────────────
        $('.carouselParaphotos').each(function () {
            var ul    = $(this);
            var count = ul.children().length;
            if (count > 1) {
                ul.bxSlider({
                    mode:         'fade',
                    speed:        1500,
                    controls:     false,
                    pager:        false,
                    auto:         true,
                    pause:        4000,
                    autoHover:    false,
                    infiniteLoop: true,
                });
            }
        });

        // ── photos (slider custom) ────────────────────────────────
        $('.sliderPhotos').each(function () {
            var $track = $(this);
            var count  = $track.children().length;
            if (count <= 1) return;

            var SPEED    = 800;
            var AUTOPLAY = 3000;

            $track.wrap('<div class="sliderPhotos-viewport"></div>');
            var $viewport = $track.parent();
            var $pager    = $('<div class="sliderPhotos-pager"></div>').insertAfter($viewport);
            var $original = $track.children();

            $original.clone(true).prependTo($track);
            $original.clone(true).appendTo($track);

            for (var i = 0; i < count; i++) {
                $pager.append(
                    '<button type="button" class="sliderPhotos-dot' +
                    (i === 0 ? ' is-active' : '') +
                    '" aria-label="Slide ' + (i + 1) + '"></button>'
                );
            }

            var $dots       = $pager.children();
            var current     = count;
            var isAnimating = false;
            var autoplayTimer;

            function getStride() {
                var $first = $track.children().first();
                return $first.outerWidth() + (parseInt($first.css('margin-right'), 10) || 0);
            }

            function setPosition(index, animate) {
                var x = -(index * getStride());
                if (animate) {
                    $track.css({ 'transition': 'transform ' + SPEED + 'ms ease-in-out', 'transform': 'translate3d(' + x + 'px, 0, 0)' });
                } else {
                    $track.css({ 'transition': 'none', 'transform': 'translate3d(' + x + 'px, 0, 0)' });
                    $track[0].offsetHeight;
                }
            }

            function updateDots() {
                var activeIndex = (((current - count) % count) + count) % count;
                $dots.removeClass('is-active').eq(activeIndex).addClass('is-active');
            }

            function goTo(index) {
                if (isAnimating) return;
                isAnimating = true;
                current = index;
                setPosition(current, true);
                updateDots();
                setTimeout(function () {
                    isAnimating = false;
                    if (current >= count * 2) {
                        current = current - count;
                        setPosition(current, false);
                    } else if (current < count) {
                        current = current + count;
                        setPosition(current, false);
                    }
                }, SPEED);
            }

            function startAutoplay() {
                stopAutoplay();
                autoplayTimer = setInterval(function () { goTo(current + 1); }, AUTOPLAY);
            }

            function stopAutoplay() {
                if (autoplayTimer) clearInterval(autoplayTimer);
            }

            $dots.on('click', function () {
                stopAutoplay();
                goTo(count + $(this).index());
                startAutoplay();
            });

            $(window).on('resize', function () { setPosition(current, false); });

            setPosition(current, false);
            startAutoplay();
        });

    } // fin initSliders()

    // 1re tentative dès que le DOM est prêt
    initSliders();

    // Filet de sécurité après chargement complet des ressources
    $(window).on('load', function () {
        if ($('.bx-wrapper').length === 0) {
            initSliders();
        }
    });

});